import type { ReactNode } from 'react';

export type ModalFullWidthProperties = {
  children: ReactNode;
  className?: string;
  fullWidthDisabled?: boolean;
};

const ModalFullWidth = ({ children, className }: ModalFullWidthProperties) => (
  <div className={className}>{children}</div>
);

export default ModalFullWidth;
